import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database"; // 1. ADDED THIS IMPORT

// ⚠️ IMPORTANT: YOUR CONFIG (UNCHANGED)
const firebaseConfig = {
  apiKey: "AIzaSyCGz24JlhJ8DmsTOxy3VohJFg2ZEuGfGV0",
  authDomain: "math-craft.firebaseapp.com",
  projectId: "math-craft",
  storageBucket: "math-craft.firebasestorage.app",
  messagingSenderId: "243278921123",
  appId: "1:243278921123:web:6654f10d63dd06bd5fae16"
};

// 1. Initialize the App
const app = initializeApp(firebaseConfig);

// 2. Initialize and Export Core Services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// 3. Initialize and Export Cloud Functions (Revised for region)
// ⚠️ REVISED: Specify your functions region. 'asia-south1' is an example.
export const functions = getFunctions(app, 'asia-south1');

// 4. Initialize and Export Realtime Database (RTDB)
// 2. ADDED THIS EXPORT
export const rtdb = getDatabase(app);

// Optional: Export the main app instance if other parts of your code need it
export const appInstance = app;
